import Add from '@material-ui/icons/Add';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import Hidden from '@material-ui/core/Hidden';
import Paper from '@material-ui/core/Paper';
import React, { Component } from 'react';
import TableCell from '@material-ui/core/TableCell';

import { EditCommandCell } from '../../../common/tableEditCommandCell';
import { dateFormatter } from '../../../utilities/dateFormatter';

import {
  DataTypeProvider,
  EditingState,
  IntegratedPaging,
  IntegratedSorting,
  PagingState,
  SortingState,
} from '@devexpress/dx-react-grid';

import {
  Grid,
  PagingPanel,
  Table,
  TableEditColumn,
  TableHeaderRow,
} from '@devexpress/dx-react-grid-material-ui';
import { setPageTitle, showToast, TOAST_MESSAGE_SEVERITY_SUCCESS } from 'modules/layout/layout.actions';
import { connect } from 'react-redux';

import { withRouter } from 'react-router-dom';
import { DELETE_POLICIES_SUCCESS, deletePolicy, GET_CLIENT_SETTINGS_SUCCESS, getClientSettings, getPolicies, POST_CLIENT_SETTINGS_SUCCESS, postClientSettings, postPolicy, UPDATE_CLIENT_SETTINGS_SUCCESS, updateClientSettings } from '../estimator.actions';
import { getSelectedClientInformation } from 'utilities/authUtils';
import FullscreenSpinner from 'common/fullscreenSpinner.component';
import ConfirmModal from 'common/confirmModal.component';
import { Switch } from '@material-ui/core';

const DateTypeProvider = (props) => (
  <DataTypeProvider formatterComponent={dateFormatter} {...props} />
);

const getRowId = (row) => row.AuthorizationID;

class Policies extends Component {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        { name: 'policyId', title: 'Policy Id' },
        { name: 'policyName', title: 'Policy Name' },
        { name: 'isPublished', title: 'Is Published', getCellValue: (row) => (<div>{row.isPublished ? 'Yes' : 'No'}</div>) },
        { name: 'enabledBenefits', title: 'Enabled Benefits', getCellValue: (row) => (<div>{row.savedBenefits ? row.savedBenefits.length : 0}</div>) },
        { name: 'createdDate', title: 'Created Date' },
      ],
      tableColumnExtensions: [{  }],
      rows: [],
      currentPage: 0,
      pageSize: 5,
      pageSizes: [5, 10, 15],
      dateColumns: ['createdDate'],
      sorting: [{ columnName: 'createdDate', direction: 'desc' }],
      modal: {
        modalConfirmOpen: false,
        contentText: '',
        type: null,
        selectedRow: null,
      },
      deletePolicyId: null,
      premiumChecked: false,
    };

    this.changeSorting = (sorting) => this.setState({ sorting });

    this.TableRow = ({ row, handleEditAuthorization, ...restProps }) => {
      return (
        <Table.Row
          {...restProps}
          onClick={() => this.props.history.push(`/estimatorPolicies/${row.policyId}`)}
          style={{
            cursor: 'pointer',
          }}
        />
      );
    };

    this.changeCurrentPage = (currentPage) => this.setState({ currentPage });
    this.changePageSize = (pageSize) => this.setState({ pageSize });
    this.commitChanges = this.commitChanges.bind(this);
    this.cancelAuth = this.cancelAuth.bind(this);
    this.createPolicy = this.createPolicy.bind(this);
    this.fetchData = this.fetchData.bind(this);
    this.deletePolicy = this.deletePolicy.bind(this);
    this.setPremiumStatus = this.setPremiumStatus.bind(this);
  }

  async cancelAuth(row) {
    this.setState({ deletePolicyId: row.row.policyId });
  }

  async deletePolicy(policyId) {
    const deleteResp = await this.props.deletePolicy(policyId);
    if (deleteResp.type === DELETE_POLICIES_SUCCESS) {
      this.props.showToast(`Successfully deleted policy ${policyId}.`, { severity: TOAST_MESSAGE_SEVERITY_SUCCESS });
      this.setState({ deletePolicyId : null });
      await this.props.getPolicies();
    }
  }

  // required for editing state
  commitChanges() {}

  actionsCell = (props) => {
    return (
      <TableCell>
        <EditCommandCell
          id="cancel"
          text="Delete"
          style={{ border: 'none' }}
          onExecute={this.cancelAuth}
          tableRow={props.tableRow}
        >
          {React.Children.toArray(props.children)}
        </EditCommandCell>
      </TableCell>
    );
  };

  createPolicy = async () => {
    let today = new Date();
    today.setDate(today.getDate() + 1);
    
    const postPolicyRep = await this.props.postPolicy({ clientId: getSelectedClientInformation().id, createdDate: today });
    if (postPolicyRep.response) {
      this.props.history.push(`/estimatorPolicies/${postPolicyRep.response.policyId}`);
    }
  }

  setPremiumStatus = async (isChecked) => {
    const clientId = getSelectedClientInformation().id;

    if (this.props.clientSettings) {
      const putClientSettingsResp = await this.props.updateClientSettings({
        clientSettingsId: this.props.clientSettings.clientSettingsId,
        clientId: this.props.clientSettings.clientId,
        isPremium: isChecked,
      });

      if (putClientSettingsResp.type === UPDATE_CLIENT_SETTINGS_SUCCESS) {
        this.props.showToast(`Successfully changed premium status for client ${clientId}.`, { severity: TOAST_MESSAGE_SEVERITY_SUCCESS });
      }
    } else {
      const postClientSettingsResp = await this.props.postClientSettings({
        clientId: clientId,
        isPremium: isChecked,
      });

      if (postClientSettingsResp.type === POST_CLIENT_SETTINGS_SUCCESS) {
        this.props.showToast(`Successfully changed premium status for client ${clientId}.`, { severity: TOAST_MESSAGE_SEVERITY_SUCCESS });
      }
    }

    this.setState({ premiumChecked: isChecked });
  }

  fetchData = async () => {
    await this.props.getPolicies();

    const clientSettingsResp = await this.props.getClientSettings();
    if (clientSettingsResp.type === GET_CLIENT_SETTINGS_SUCCESS) {
      this.setState({ premiumChecked: clientSettingsResp.response ? clientSettingsResp.response.isPremium : false });
    }
  }

  componentDidMount() {
    this.props.setPageTitle('My Policies');

    this.fetchData();
  }

  render() {
    const { policies } = this.props;
    const {
      columns,
      pageSize,
      pageSizes,
      currentPage,
      dateColumns,
      sorting,
      tableColumnExtensions,
      premiumChecked,
    } = this.state;

    return (
      <Box sx={{padding: '2rem'}}>


        <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '1rem' }}>
          <div style={{ padding: '0.3rem', fontSize: '1.25rem' }}>
            Premium Cost Estimator
          </div>
          <Box sx={{ marginTop: '3px' }}>
            <Switch 
              label="" 
              checked={premiumChecked}
              onChange={() => { this.setPremiumStatus(!premiumChecked); }}
            />
          </Box>
        </Box>

        {this.state.deletePolicyId && (
          <ConfirmModal
            cancelText="Cancel"
            confirmText="Confirm"
            handleClose={() => { this.setState({ deletePolicyId: null}) }}
            handleConfirm={() => { this.deletePolicy(this.state.deletePolicyId) }}
            titleText="Unsaved Changes"
            bodyText={`Are you sure you would like to delete policy ${this.state.deletePolicyId}?`}
          />
        )}

        <Button
            variant="contained"
            size="small"
            color="primary"
            disabled={!premiumChecked}
            onClick={this.createPolicy}
            style={{ float: 'right', marginTop: '1rem', marginRight: '1rem' }}
        >
            <Add />
            <Hidden mdUp>New Policy</Hidden>
            <Hidden smDown>New Policy</Hidden>
        </Button>

        <Paper style={{ padding: '0.5rem' }}>
          <div style={{ padding: '0.3rem', fontSize: '1.25rem' }}>
            Saved Policies
          </div>
          {!policies && <FullscreenSpinner/>}
          {policies && (
            <Grid rows={policies} columns={columns} getRowId={getRowId}>
              <DateTypeProvider for={dateColumns} />
              <EditingState
                onEditingRowIdsChange={this.changeEditingRowIds}
                onCommitChanges={this.commitChanges}
              />
              <SortingState
                sorting={sorting}
                onSortingChange={this.changeSorting}
              />
              <PagingState
                currentPage={currentPage}
                onCurrentPageChange={this.changeCurrentPage}
                pageSize={pageSize}
                onPageSizeChange={this.changePageSize}
              />
              <IntegratedSorting />
              <IntegratedPaging />
              <Table
                rowComponent={this.TableRow}
                columnExtensions={tableColumnExtensions}
              />
              <TableHeaderRow showSortingControls />
              <TableEditColumn
                style={{ marginRight: '2rem' }}
                cellComponent={this.actionsCell}
              />
              {policies && policies.length > 5 && <PagingPanel pageSizes={pageSizes} />}
            </Grid>
          )}
        </Paper>
      </Box>
    );
  }
}

const mapStateToProps = (state) => {
    return {
      policies: state.estimator.get('policies'),
      clientSettings: state.estimator.get('clientSettings'),
    };
};
  
export default withRouter(connect(mapStateToProps, {
    setPageTitle,
    getPolicies,
    postPolicy,
    deletePolicy,
    showToast,
    updateClientSettings,
    postClientSettings,
    getClientSettings,
})(Policies));